module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("your profile")]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    staticClass: "playlist",
    class: {
      current: _vm.tabs.playlist
    },
    style: ([_vm.tabs.playlist ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/playlist')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.playlist ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("playlists")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.coolFeatures
    },
    style: ([_vm.tabs.coolFeatures ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/myprogress')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.coolFeatures ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("your Progress")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.chat
    },
    style: ([_vm.tabs.chat ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/personalize')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.chat ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("personalize")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.videos
    },
    style: ([_vm.tabs.videos ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/myfav')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.videos ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("your faves")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.discussion
    },
    style: ([_vm.tabs.discussion ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('discussion')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.discussion ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("account")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.coolFeatures
    },
    attrs: {
      "id": "tabs-5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.userProgressTakeaways) ? _c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('strong', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Look what You’ve Accomplished!")])]) : _c('h2', {
    staticClass: "heading"
  }, [_c('strong', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading1))])]), _vm._v(" "), (!_vm.userProgressTakeaways) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Now is the BEST time to invest in YOU.")]) : _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading2))]), _vm._v(" "), (_vm.userProgressTakeaways) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading3))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 bottom-margin"
  }, [_c('div', {
    staticClass: "progressbarsholder",
    class: {
      'expand': _vm.expandPlaylistPanel
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.isPlaylistWatched) ? _c('h3', [_vm._v("Playlists in Progress")]) : _c('h3', [_vm._v("Playlists for You")]), _vm._v(" "), _vm._l((_vm.userProgressPlaylists), function(playlist) {
    return _c('div', [_c('h4', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playProgressPlaylist(playlist.playlistId, playlist.playlistTypeDesc, playlist.title, playlist.lastSeenVideoCode, playlist.lastSeenVideoTitle)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))]), _vm._v(" "), _c('div', {
      staticClass: "progessandstar"
    }, [_c('div', {
      staticClass: "progress  mb-3"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: (_vm.returnProgressStyle(Math.round(playlist.percentWatched))),
      attrs: {
        "d": "",
        "role": "progressbar",
        "aria-valuenow": "75",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    })]), _vm._v(" "), (Math.round(playlist.percentWatched) === 100) ? _c('i', {
      staticClass: "fa fa-star"
    }) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    on: {
      "click": function($event) {
        _vm.expandPlaylistPanel = !_vm.expandPlaylistPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bottom-margin"
  }, [_c('div', {
    staticClass: "pinkputlinepannel",
    class: {
      'expand': _vm.expandEventsAttendedPanel
    },
    style: ({
      borderWidth: '5px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.userProgressEventsAttended && _vm.userProgressEventsAttended.length > 0) ? _c('div', [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Events Attended")]), _vm._v(" "), _c('ul', _vm._l((_vm.userProgressEventsAttended), function(event) {
    return _c('li', {
      staticClass: "mobile-event-star"
    }, [_c('i', {
      staticClass: "fa fa-star showmobile"
    }), _vm._v(_vm._s(event.event_title)), _c('strong', [_vm._v(" --  " + _vm._s(event.expert_name) + " ")])])
  }), 0)]) : _c('div', [(_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Upcoming Event")]) : _vm._e(), _vm._v(" "), (_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null && _vm.getExpert) ? _c('h4', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/event')
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.upcomingProfileEvent.title) + " with " + _vm._s(_vm.getExpert[0].name) + " on " + _vm._s(_vm.getDateReference(_vm.upcomingProfileEvent.start_date, 'str')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.upcomingProfileEvent) ? _c('h4', {
    staticStyle: {
      "text-align": "justify",
      "text-justify": "inter-word"
    }
  }, [_vm._v(_vm._s(_vm.upcomingProfileEvent.longDescription))]) : _vm._e(), _vm._v(" "), (_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null) ? _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.upcomingProfileEvent.start_date, 'str')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    on: {
      "click": function($event) {
        _vm.expandEventsAttendedPanel = !_vm.expandEventsAttendedPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    style: ({
      color: _vm.getCorpHeaderColor + ' !important'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pinkputlinepannel",
    class: {
      'expand': _vm.expandVideosWatchedPanel
    },
    style: ({
      borderWidth: '5px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.isSectionWatched) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Videos Watched")]) : _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Here are some videos to get your started")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ul', _vm._l((_vm.userProgressVideosWatched), function(video) {
    return _c('li', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playWatchedVideo(video.video_code, video.video_title)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(video.video_title))])])
  }), 0)]), _vm._v(" "), (_vm.isSectionWatched) ? _c('div', {
    staticClass: "col-md-4 watcedvideotitle",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("\n                                            TOTAL WATCHED "), _c('br'), _vm._v(" "), (_vm.userProgressVideosWatched) ? _c('span', {
    staticClass: "totalwatched"
  }, [_vm._v("\n                                               " + _vm._s(_vm.userProgressVideosWatched.length) + "\n                                            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    on: {
      "click": function($event) {
        _vm.expandVideosWatchedPanel = !_vm.expandVideosWatchedPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 bottom-margin"
  }, [_c('div', {
    staticClass: "takeawaysholder",
    class: {
      'expand': _vm.expandTakeawayPanel
    }
  }, [_c('h3', [_vm._v("TONE TAKEAWAYS")]), _vm._v(" "), _vm._l((_vm.userProgressTakeaways), function(takeaways) {
    return (_vm.userProgressTakeaways && _vm.userProgressTakeaways.length > 0) ? _c('div', [_c('h4', [_c('strong', [_vm._v(_vm._s(takeaways.video_title))])]), _vm._v(" "), _c('ul', _vm._l((takeaways.tone_takeaways), function(tk) {
      return _c('li', [_c('strong', [_vm._v(_vm._s(tk))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (!_vm.userProgressTakeaways) ? _c('div', [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng1))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng2))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng3))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng4))])])]) : _vm._e(), _vm._v(" "), (_vm.userProgressTakeaways && _vm.userProgressTakeaways.length > 0) ? _c('button', {
    staticClass: "downbutton",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    on: {
      "click": function($event) {
        _vm.expandTakeawayPanel = !_vm.expandTakeawayPanel
      }
    }
  }, [(_vm.expandTakeawayPanel) ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.userProgressTakeaways ? 'MORE TAKEAWAYS' : ''))]), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthUserFavVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getAuthUserFavVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v("\n                                        " + _vm._s(video.title) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "btn-group plusicon"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Remove Video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o activeIcons",
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getAuthUserFavVideos && _vm.getAuthUserFavVideos.length == 0) ? _c('div', [_vm._m(3)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlist
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.personalPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userPersonalPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userPersonalPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.removePlaylist(playlist.playlistId)
        }
      }
    }), (playlist.haveCorporationVideo === 0 && ((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'personal')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _c('div', [_c('h1', {
    staticClass: "favesText",
    attrs: {
      "text-center": "",
      "text-muted": "",
      "margin-bottom-40": ""
    }
  }, [_vm._v("Your personal playlists folder is empty. Start saving your video collection today by clicking the "), _c('span', [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" icon next to any video to create your first playlist")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.userCorpSharedPlaylists) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(_vm.user.corporation.playlistHeading) ? _c('h3', [_vm._v(_vm._s(_vm.user.corporation.playlistHeading))]) : _c('h3', [_vm._v(_vm._s(_vm.corpPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userCorpSharedPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userCorpSharedPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'corporate')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.userCuratedPlaylists) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.trendingPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userCuratedPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userCuratedPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), (playlist.haveCorporationVideo === 0 && ((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'trending')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.chat
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "container personalize"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12  interestlist"
  }, [_c('div', [_vm._m(5), _vm._v(" "), (_vm.getAllInterests && _vm.getUserInterests) ? _c('div', {
    staticClass: "interest-container"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, [_vm._l((_vm.getAllInterests), function(interest, interestId) {
    return _c('span', [_c('span', [_c('checkbox', {
      key: interestId,
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interestId)),
      attrs: {
        "true-value": interestId
      }
    }, [_vm._v("\n                                                            " + _vm._s(interest.interestName) + "\n                                                        ")])], 1)])
  }), _vm._v(" "), (_vm.getAllInterests) ? _c('button', {
    staticClass: "min-padding checkbox-btn",
    style: ([_vm.toggleStatus ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    } : {
      color: _vm.getCorpButtonColor + '!important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }]),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleStatus = !_vm.toggleStatus
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" I want it all!")]) : _vm._e()], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "interest-container",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('button-group', {
    staticStyle: {
      "margin": "25px"
    },
    model: {
      value: (_vm.selectedDays),
      callback: function($$v) {
        _vm.selectedDays = $$v
      },
      expression: "selectedDays"
    }
  }, _vm._l((_vm.daysOfWeek), function(day, index) {
    return _c('span', [_c('span', [_c('checkbox', {
      key: index,
      staticClass: "min-padding checkbox-btn-days",
      style: (_vm.styleDays(index)),
      attrs: {
        "true-value": index
      }
    }, [_vm._v("\n                                                                " + _vm._s(day) + "\n                                                            ")])], 1)])
  }), 0)], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "updateInterest",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    attrs: {
      "type": "button",
      "disabled": _vm.interestIndexes.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.updateInterests()
      }
    }
  }, [_vm._v("\n                                        UPDATE\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.discussion
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [((_vm.getCardExpiryDays < 0 && _vm.user.ccExpAlarmFlag === 2)) ? _c('h3', {
    staticClass: "pinkh3"
  }, [_vm._v("You payment method has expired. Please update your information to access your TONE account.")]) : _vm._e(), _vm._v(" "), ((_vm.user.ccExpAlarmFlag === 2 && (_vm.getCardExpiryDays > 0 && _vm.getCardExpiryDays < 5)) && _vm.user.ccExpiryDate) ? _c('h3', {
    staticClass: "pinkh3"
  }, [_vm._v("You payment method is expiring in " + _vm._s(_vm.getCardExpiryDays) + " "), (_vm.getCardExpiryDays > 1) ? _c('span', [_vm._v("days.")]) : _c('span', [_vm._v("day.")]), _vm._v(" Please update your information to access your TONE account.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row accountContentBox"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "accountLeft"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [(_vm.user.picture) ? _c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png",
      "alt": "USER-PROFILE",
      "title": "Profile Image"
    }
  }) : _vm._e()]) : _c('span', [(_vm.user.picture) ? _c('img', {
    attrs: {
      "src": _vm.getRelatedImage(_vm.user.picture),
      "alt": "USER-SHOE",
      "title": "Profile Image"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._v("\n                                        Profile Image\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span') : _c('span', [(_vm.imageText) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.imageText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getDefaultImages) ? _c('div', {
    staticClass: "slider responsive-slick-imagelist"
  }, _vm._l((_vm.getDefaultImages), function(getDefaultImage) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": getDefaultImage.smallImgUrl,
        "alt": getDefaultImage.title,
        "title": getDefaultImage.title
      },
      on: {
        "click": function($event) {
          return _vm.setDefaultImage(getDefaultImage)
        }
      }
    }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.picture !== getDefaultImage.smallImgUrl) ? _c('button', {
      staticClass: "carousalbutton",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      }),
      on: {
        "click": function($event) {
          return _vm.setDefaultImage(getDefaultImage)
        }
      }
    }, [_vm._v("\n                                                    Select\n                                                ")]) : _vm._e(), _vm._v(" "), (_vm.user.picture === getDefaultImage.smallImgUrl) ? _c('button', {
      staticClass: "carousalbutton selected",
      attrs: {
        "diabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Selected\n                                                ")]) : _vm._e()])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.user && (_vm.user.corporation && _vm.user.corporation.enableCorporatePage === 1)) ? _c('button', {
    staticClass: "btn formButton btn-block",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('corporation/mycommunity')
      }
    }
  }, [_vm._v("Enter My Community Page\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.user && (_vm.user.corporation && _vm.user.corporation.pageAdmin === _vm.user.userId)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/corporation/manage-page')
      }
    }
  }, [_c('h4', [_vm._v("Manage Custom Features")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accountRight"
  }, [_c('form', [_c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Name: "), _c('a', {
    class: {
      hidden: _vm.showUpdateNameBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateName
    }
  }, [_vm._v("update")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " ")]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdateNameBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onNameSubmit()
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_updatedfirstname",
      "type": "text",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedFirstName),
      callback: function($$v) {
        _vm.updatedFirstName = $$v
      },
      expression: "updatedFirstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_updatedlastname",
      "type": "text",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedLastName),
      callback: function($$v) {
        _vm.updatedLastName = $$v
      },
      expression: "updatedLastName"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateName
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updatename",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [(_vm.user.status.toLowerCase() === 'register' || _vm.user.status.toLowerCase() === 'registered') ? _c('div', [_vm._m(7)]) : _c('div', [_c('h4', [_vm._v("Email: "), _c('a', {
    class: {
      hidden: _vm.showUpdateEmailBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateEmail
    }
  }, [_vm._v("change")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdateEmailBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onEmailChangeSubmit.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_oldEmail",
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    model: {
      value: (_vm.oldPasswordForEmail),
      callback: function($$v) {
        _vm.oldPasswordForEmail = $$v
      },
      expression: "oldPasswordForEmail"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "profile_new_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "New Email Address",
      "name": "email",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.newEmail),
      callback: function($$v) {
        _vm.newEmail = $$v
      },
      expression: "newEmail"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateEmail
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updateEmail",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Password: "), _c('a', {
    class: {
      hidden: _vm.showUpdatePasswordBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePassword
    }
  }, [_vm._v("change")])]), _vm._v(" "), _c('h5', [_vm._v("******************")]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdatePasswordBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPasswordSubmit.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_oldpassword",
      "type": "password",
      "placeholder": "Old Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "id": "profile_newpassword",
      "error": "Password is Required",
      "type": "password",
      "placeholder": "Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedPassword),
      callback: function($$v) {
        _vm.updatedPassword = $$v
      },
      expression: "updatedPassword"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "id": "profile_confirmPassword",
      "error": "Confirm Password is Required",
      "type": "password",
      "placeholder": "Confirm Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePassword
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updatepassword",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.verifyPassword()),
      expression: "!verifyPassword()"
    }],
    attrs: {
      "placement": "top",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "profile_pwderrormsg"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])])], 1), _vm._v(" "), (_vm.getProfileCharitySection) ? _c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Selected Charity: "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCharityUpdate),
      expression: "!isCharityUpdate"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.isCharityUpdate = true
      }
    }
  }, [_vm._v("update")])]), _vm._v(" "), (_vm.getSelectedCharity && _vm.getSelectedCharity !== '{}') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.getSelectedCharity.img_url,
      "alt": "Selected Charity",
      "title": _vm.getSelectedCharity.name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "SelectedCharityName"
  }, [_vm._v(_vm._s(_vm.getSelectedCharity.name))])]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCharityUpdate),
      expression: "isCharityUpdate"
    }],
    staticClass: "updateName selectedCharityBtn",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCharity.apply(null, arguments)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.isCharityUpdate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": ""
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.getAlertMsgStatus) ? _c('div', {
    staticClass: "formName",
    class: {
      highlight: (_vm.getCardExpiryDays < 5 && _vm.user.ccExpAlarmFlag === 2)
    }
  }, [_c('h4', {
    attrs: {
      "id": "updatepaymentmethod"
    }
  }, [_vm._v("Payment Method:"), _c('a', {
    class: {
      hidden: _vm.showPaymentBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePayment
    }
  }, [_vm._v("change")])]), _vm._v(" "), (!_vm.isStripe) ? _c('div', {
    staticClass: "row notstripes"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.isStripe) ? _c('h5', [_vm._v("PayPal")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  }), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_vm._m(8)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isStripe && _vm.getCreditCardInfo) ? _c('h5', {
    staticClass: "paymentmethodh5"
  }, [_vm._v(_vm._s(_vm.getCreditCardInfo))]) : _vm._e(), _vm._v(" "), _c('h6', [_c('a', {
    class: {
      hidden: _vm.showPaymentHistoryBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showPaymentHistory
    }
  }, [_vm._v("View Billing History")])]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showPaymentBox
    },
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onNewCardSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.isStripe) ? _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePayment
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_changecc",
      "disabled": _vm.showPaymentHistoryBox
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), (_vm.showPaymentHistoryBox) ? _c('div', [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Billing History")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getBillingHistory) ? _c('div', [(_vm.getBillingHistory) ? _c('table', {
    staticClass: "table table--lg team-roster-table table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((_vm.getBillingHistory), function(record) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(record.paymentDateFmt))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(record.paymentType))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("$" + _vm._s(record.paidAmountFmt))])])
  }), 0)]) : _vm._e()]) : _c('div', [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No record to display!")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showPaymentHistory
    }
  }, [_vm._v("Hide Billing History")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getAlertMsgStatus && _vm.getTrialDays <= 30 && (_vm.user && _vm.user.corporation === null || _vm.user && _vm.user.corporation && _vm.user.corporation.trialExpiryMsgFlag)) ? _c('div', {
    staticClass: "formName"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/becomemember')
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.expiredTrialMessage))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [(_vm.user.status === 'CANCELLED') ? _c('div', [_c('h3', {
    staticClass: "alert alert-danger"
  }, [_vm._v("Request for Cancellation has been sent. Check your email for confirmation")])]) : _c('div', [_c('h4', [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("cancel")])]), _vm._v(" "), _c('h5', [_vm._v("Cancel Your Subscription")])])])])])])])])])])])]), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                                Send Email\n                                "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("make it easy!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "favesText",
    attrs: {
      "text-center": "",
      "text-muted": "",
      "margin-bottom-40": ""
    }
  }, [_vm._v("Your faves folder is empty. Start saving your bite-sized collection today by clicking the "), _c('span', [_c('i', {
    staticClass: "fa fa-x fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" after watching a clip you love")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "personalizeText"
  }, [_vm._v("\n                                       As part of your membership, TONE delivers two, short videos chosen specifically for you based on your selected preferences.\n                                       Tell us what you like and we’ll send you more of the content you love!\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7 box-size"
  }, [_c('div', {
    staticClass: "main-content text-left pt-3"
  }, [_c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("\n                                                Topics Of Interest:\n                                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerlevel3 text-left"
  }, [_c('h3', {
    staticClass: "profile-heading"
  }, [_vm._v("TONE Teaser Delivery Days (choose at least two days):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "alert alert-info"
  }, [_vm._v("Your new email account needs to be validated. "), _c('br'), _vm._v(" Check your email and follow the link")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized with Paypal")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6144c6ea", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6144c6ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Profile.vue